import { AppConfigResponseDto } from "../common/dto/config/app-config-response.dto";
import { backendClient, unwrapResponse } from "./backendClient";

export async function getAppConfig(): Promise<AppConfigResponseDto> {
    return unwrapResponse(await backendClient.get("/app-config"));
}
